import { defineMessageUnion } from "foldkit/message";

export const Message = defineMessageUnion({
	ClickedGoBack: {},
	CompletedGoBack: {},
});
export type Message = typeof Message.Type;
